const initialState = () => ({
  files: [],
  franchises: [],
  locations: [],
  roleUsers: [],
  logFiles: [],
  elementFile: null
})

export default initialState
